import React, { useState, useEffect } from 'react';
import Classes from '../MainLayout.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import sessionstorage from 'sessionstorage';
import { authActions } from '../../../../redux-store';
import { useSelector } from 'react-redux';
import Logo from '../../LocalComp/Logo/Logo';
import { DashboardIcon, SettingsIcon, LogoutIcon, MeetingsIcon, MessageIcon, ProfileIcon, CalenderIcon, AvailabilityIcon } from '../../../../utils/Icons';

export default function Sidebar({
    isMobile,
    setopenMobileSidebar,
}) {
    const navigateTo = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.auth);
    const onBoarding = useSelector((state) => state.companyInfo.info);
    const companyId = onBoarding?._id;
    const userId = user?._id;

    const [activePage, setActivePage] = useState(location.pathname);

    useEffect(() => {
        setActivePage(location.pathname);
    }, [location.pathname]);

    const handleLogout = async () => {
        localStorage.clear();
        sessionstorage.clear();
        navigateTo('/');
        await dispatch(authActions.logout());
    };

    const handleNavigate = (page) => {
        navigateTo(page);
        if (isMobile) {
            setopenMobileSidebar(false);
        }
    };

    return (
        <aside className={Classes.sidebar}>
            <div>
                <div className={Classes.logo}>
                    <Logo alwaysShowText={true} />
                </div>
                <nav className={Classes.navMenu}>
                    <h5>ACTIVITY</h5>
                    <ul>
                        <li
                            onClick={() => handleNavigate('/')}
                            className={activePage === '/' ? Classes.navActive : ''}
                        >
                            <div className={Classes.svgIcon} >
                                <DashboardIcon height='17px' fill={activePage === '/' ? '#F26A63' : 'black'} />
                            </div>

                            {isMobile ? 'Dashboard' : 'Mentor Dashboard'}

                        </li>
                        <li
                            onClick={() => handleNavigate('/meetings')}
                            className={activePage === '/meetings' ? Classes.navActive : ''}
                        >
                            <div className={Classes.svgIcon} >
                                <CalenderIcon height='17px' fill={activePage === '/meetings' ? '#F26A63' : 'black'} />
                            </div>
                            Meetings
                        </li>
                        <li
                            onClick={() => handleNavigate('/messages')}
                            className={activePage === '/messages' ? Classes.navActive : ''}
                        >
                            <div className={Classes.svgIcon} >
                                <MessageIcon height='17px' fill={activePage === '/messages' ? '#F26A63' : 'black'} />
                            </div>
                            Messages
                        </li>
                    </ul>
                    <h5>PROFILE</h5>
                    <ul>
                        <li
                            onClick={() => handleNavigate('/profile')}
                            className={activePage === '/profile' ? Classes.navActive : ''}
                        >
                            <div className={Classes.svgIcon} >
                                <ProfileIcon height='17px' fill={activePage === '/profile' ? '#F26A63' : 'black'} />
                            </div>
                            Profile
                        </li>
                        <li
                            onClick={() => handleNavigate('/availability')}
                            className={activePage === '/availability' ? Classes.navActive : ''}
                        >
                            <div className={Classes.svgIcon} >
                                <AvailabilityIcon height='20px' fill={activePage === '/availability' ? '#F26A63' : 'black'} />
                            </div>
                            Availability
                        </li>
                    </ul>

                    <h5>ACCOUNT</h5>
                    <ul>
                        <li
                            onClick={() => handleNavigate('/settings')}
                            className={activePage === '/settings' ? Classes.navActive : ''}
                        >
                            <div className={Classes.svgIcon} >
                                <SettingsIcon height='17px' fill={activePage === '/settings' ? '#F26A63' : 'black'} />
                            </div>
                            Settings
                        </li>
                        <li onClick={() => handleLogout()}>
                            <div className={Classes.svgIcon} >
                                <LogoutIcon height='17px' fill={'black'} />
                            </div>
                            Log Out
                        </li>
                    </ul>
                </nav>
            </div>
        </aside>
    );
}
